export default __webpack_public_path__ + "static/media/search-close-light.7679bc22.svg";